import { Link } from "react-router-dom";
import { CaretLeft, Shield } from "@phosphor-icons/react";

// Featured admin card — visually distinct, gold-trimmed call-to-action.
// Rendered only when both a user and confirmed admin session exist.
export default function AdminFeatureCard() {
  return (
    <Link
      to="/admin"
      data-testid="account-admin-card"
      className="block mt-3 rounded-[24px] overflow-hidden active:scale-[0.98] transition-transform"
      style={{
        background: "linear-gradient(135deg, #0A192F 0%, #1F3556 100%)",
        boxShadow: "0 8px 28px rgba(10,25,47,0.28)",
      }}
    >
      <div className="relative p-5 flex items-center gap-4">
        <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full bg-[#D4AF37]/20 blur-2xl pointer-events-none" />
        <div className="w-14 h-14 rounded-2xl bg-[#D4AF37] flex items-center justify-center shrink-0 shadow-lg">
          <Shield size={28} weight="fill" color="#0A192F" />
        </div>
        <div className="flex-1 text-start text-white">
          <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#D4AF37]/25 text-[#D4AF37] text-[10px] font-bold tracking-[0.2em] mb-1 uppercase">
            مدير النظام
          </div>
          <div className="text-[17px] font-tajawal font-bold leading-tight">لوحة الإدارة</div>
          <div className="text-[12.5px] font-tajawal text-white/70 mt-0.5">
            إدارة المستخدمين، المحامين، وقرارات التمييز
          </div>
        </div>
        <CaretLeft size={18} weight="bold" className="text-white/70" />
      </div>
    </Link>
  );
}
